export const REACT_APP_API_URL = "REACT_APP_API_URL";
export const REACT_APP_WIDGET_APP_URL = "REACT_APP_WIDGET_APP_URL";
export const REACT_APP_WIDGET_DEV_HOST = "REACT_APP_WIDGET_DEV_HOST";

export function getEnv(name) {
  // @ts-ignore
  return (window._env_ && window._env_[name]) || process.env[name] || "";
}
